import { render, staticRenderFns } from "./ApplyDocFilterComponent.vue?vue&type=template&id=23f78b35&scoped=true&"
import script from "./ApplyDocFilterComponent.vue?vue&type=script&lang=js&"
export * from "./ApplyDocFilterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f78b35",
  null
  
)

export default component.exports